export const en = {
  app: {
    error: {
      title: "The page could not be loaded",
      description:
        "A new version may be available. Reload the page to continue.",
      reload: "Reload page",
    },
  },
  actions: {
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    finalize: "Finalize",
    close: "Close",
    archive: "Archive",
    delete: "Delete",
    edit: "Edit",
    resolve: "Done",
    save: "Save",
    new: "New",
  },
  common: {
    name: "Name",
    personal: "Personal",
    description: "Description",
    emptyDescription: "No description",
    optional: "Optional",
    organization: "Organization",
    template: "Template",
    templates: "Templates",
    organizations: "Organizações",
    general: "General",
    configuration: "Configuration",
    orderBy: "Order by:",
    changeStatus: "Change status",
    image: "Image",
    images: "Images",
    attachments: "Attachments",
    unavailableImage: "Unavailable image",
    unset: "Unset",
    history: "History",
    createdAt: "Created at",
    createdBy: "Created by",
    updatedAt: "Updated at",
    updatedBy: "Updated by",
    viewAllHistory: "View complete history",
    addTags: "Add tags",
    pickDate: "Pick a date",
    imageDropArea: "Drop images here or click to upload",
    tags: "Tags",
  },
  images: {
    selectImage: "Select image",
  },
  appbar: {
    searchText: "Search anything...",
    accountMenu: {
      account: "My account",
      theme: "Theme",
      language: "Language",
      signOut: "Sign out",
    },
  },
  projects: {
    title: "Projects",
    description: "Manage and create your projects",
    create: "Create project",
    form: {
      title: "Create and manage issues and more using Floorbit Projects.",
      namePlaceholder: "Provide a name to your project",
      descriptionPlaceholder: "You can also provide a description",
      projectImage: "Project image",
      templateDescription: "Use a template to create a pre-configured project.",
      personalProjectDescription: "Only you will see this project.",
      organizationProjectDescription:
        "All in the organization will see this project.",
      selectTemplate: "Select a template",
    },
    tabs: {
      activity: "Activity",
      issues: "Issues",
      board: "Board",
      files: "Files",
      models: "Models",
      statistics: "Statistics",
      people: "People",
      settings: "Settings",
      team: "Team",
    },
    empty: {
      title: "Out of projects!",
      description: "You currently don't have access to any project.",
      create: "Create your first project",
    },
    storeys: {
      zone: "Zone",
      tower: "Tower",
      defaultZoneName: "Zone",
      zoneTower: "zone/tower",
      storey: "Storey",
      area: "Area",
    },
    statistics: {
      description: "Follow the key indicators for this project.",
      issuesByStatus: "Issues by status",
      issuesByStatusDescription:
        "Distribution of all published issues in this project.",
      totalIssues: "Total issues",
    },
    models: {
      title: "IFC models",
      description:
        "Upload and follow the processing of this project's IFC models.",
      add: "Add IFC model",
      addFirst: "Add your first IFC model",
      dropActiveTitle: "Release to upload the IFC model",
      dropActiveDescription: "The model will begin processing after upload.",
      uploading: "Uploading {{progress}}%",
      uploadStarted: "IFC uploaded. Geometry processing has started.",
      uploadFailed: "The IFC model could not be uploaded.",
      invalidFile: "Select a valid .ifc file.",
      invalidSize: "The IFC file must be smaller than 2 GB.",
      duplicateName:
        "An IFC model with this name already exists in the project.",
      actions: "Model actions",
      download: "Download IFC",
      downloading: "Preparing download",
      downloadFailed: "The IFC model could not be downloaded.",
      edit: "Update",
      delete: "Delete model",
      replacing: "Uploading {{progress}}%",
      replacementStarted:
        "Model updated. The new geometry processing has started.",
      replacementFailed: "The IFC model could not be updated.",
      replacementNameMismatch:
        "To update this model, select a file named {{name}}.",
      modelBusy:
        "Wait for the current processing to finish before changing the model.",
      deleteTitle: "Delete IFC model?",
      deleteDescription:
        "{{name}} and all of its processed files will be permanently deleted.",
      deleteAction: "Delete model",
      deleteSuccess: "IFC model deleted.",
      deleteFailed: "The IFC model could not be deleted.",
      processingStarted: "Geometry processing has started.",
      processingFailed: "Geometry processing could not be started.",
      failedDescription:
        "The model could not be processed. Try processing it again.",
      process: "Process",
      updated: "Updated {{date}}",
      emptyTitle: "No IFC models",
      emptyDescription: "The project's IFC models will appear here.",
      status: {
        PENDING_UPLOAD: "Waiting for upload",
        UPLOADED: "Ready to process",
        QUEUED: "Queued",
        PROCESSING: "Processing",
        COMPLETED: "Ready",
        FAILED: "Failed",
      },
      view: "View",
      generatingPreview: "Generating preview",
      thumbnailAlt: "Preview of {{name}}",
      previewAlt: "Expanded preview of {{name}}",
      previewUnavailable: "Preview unavailable",
      federation: {
        action: "Federate",
        onlyOneAllowed: "Only one federation is allowed per project.",
        publish: "Publish",
        modelPublished: "Model published to the federation.",
        publishFailed: "The model could not be published to the federation.",
        badge: "Federation",
        selected: "{{count}} selected",
        clearSelection: "Clear model selection",
        selectModel: "Select {{name}}",
        confirmTitle: "Federate selected models?",
        confirmDescription:
          "The {{count}} selected models will open together and can no longer be opened or deleted individually.",
        created: "Federation created. Its combined preview is being generated.",
        createFailed: "The selected models could not be federated.",
        memberCount: "{{count}} models",
        generatingPreview: "Generating preview",
        processingModel: "Processing updated model",
        thumbnailAlt: "Preview of {{name}}",
        removeMember: "Defederate",
        memberRemoved: "Model defederated.",
        memberRemoveFailed: "The model could not be defederated.",
        addModels: "Add models",
        addModelsTitle: "Add models to federation",
        addModelsDescription:
          "Select one or more available models to include in {{name}}.",
        noAvailableModels: "There are no processed models available to add.",
        addSelected: "Add {{count}} models",
        modelsAdded: "Models added. The combined preview is being regenerated.",
        addModelsFailed: "The selected models could not be added.",
        dissolve: "Defederate all",
        dissolveTitle: "Defederate all models?",
        dissolveDescription:
          "The federation will be removed. Its IFC models and processed data will be preserved.",
        dissolved: "Federation removed.",
        dissolveFailed: "The federation could not be removed.",
      },
    },
  },
  viewer: {
    loading: {
      title: "Opening the viewer",
      access: "We are validating your access to the project and IFC model.",
      accessLabel: "Checking project and model",
      locating:
        "The model is ready. We are preparing secure access to its processed geometry.",
      locatingLabel: "Locating the model geometry",
      downloadingTitle: "Downloading the IFC model",
      downloadingDescription:
        "We are downloading the optimized geometry for {{fileName}}. Large models may take a moment.",
      modulesTitle: "Loading the 3D tools",
      modulesDescription:
        "We are loading the viewing engine required to navigate this model.",
      modulesLabel: "Starting the 3D environment",
      preparingTitle: "Preparing the model",
      preparingDescription:
        "The geometry is downloaded. We are now building the scene and positioning the camera.",
      preparingLabel: "Rendering model",
    },
    error: {
      title: "The model could not be opened",
      description:
        "The viewer could not load this model right now. Return to the list and try again.",
      notReady:
        "This model has not finished processing yet. Wait for it to complete before opening it.",
    },
    actions: {
      menu: "Model actions",
      back: "Back to models",
      reload: "Reload model",
      collapsePanels: "Collapse side panels",
      expandPanels: "Expand side panels",
      openViewpoint: "Open saved model viewpoint",
      openViewpointError: "The saved model viewpoint could not be opened.",
    },
    tree: {
      title: "Model tree",
      geometryGroups: "{{count}} geometry groups",
      preparing: "Preparing geometry",
    },
    controls: {
      fit: "Fit model",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
    },
    itemTools: {
      title: "Item tools",
      cutVertical: "Cut vertical",
      cutHorizontal: "Cut horizontal",
      hide: "Hide",
      hideAllExcept: "Hide all except",
      showAll: "Show all",
      addIssue: "Add issue",
      addIssueDisabled:
        "Issues can only be added in the project federation, or in its first model when there is no federation.",
    },
    issueForm: {
      title: "Add issue",
      description: "The current view and pin will be saved with this issue.",
      titlePlaceholder: "Issue title",
      disciplinePlaceholder: "Select discipline",
      disciplineSearchPlaceholder: "Search disciplines",
      disciplineSearchEmpty: "No disciplines found",
      priorityPlaceholder: "Select priority",
      descriptionPlaceholder: "Describe the issue",
      createDraft: "Create as draft",
      createError: "The viewer issue could not be created.",
      fields: {
        title: "Title",
        discipline: "Discipline",
        priority: "Priority",
        description: "Description",
      },
    },
    details: {
      title: "Model details",
      properties: "Properties",
      issues: "Issues",
      issuesEmpty: "No project issues",
      issuesDescription:
        "Issues created from any model in this project will appear here.",
      issuesLoadError: "The project issues could not be loaded.",
      issuesRetry: "Try again",
      issuesFilter: "Filter issues",
      issuesFilterDiscipline: "Discipline",
      issuesFilterAllDisciplines: "All disciplines",
      issuesFilterEmpty: "No issues match this filter",
      issueCurrentResource: "This viewer",
      issueProject: "Project",
    },
    properties: {
      name: "Name",
      size: "IFC size",
      geometryGroups: "Geometry groups",
      triangles: "Triangles",
      color: "Color",
      selectedHint:
        "Click an empty area of the model to return to its general properties.",
      modelHint: "Select part of the model to inspect its geometry properties.",
    },
  },
  issues: {
    title: "Issues",
    titlePlaceholder: "Provide the issue title",
    descriptionPlaceholder: "Describe the issue",
    item: "Issue",
    create: "Create issue",
    category: "Category",
    dueDate: "Due date",
    assignee: "Assignee",
    assignees: "Assignees",
    updatingIssue: "Updating issue",
    creatingIssue: "Creating issue",
    issueSubtitle:
      "Record an observation, pending issue, or request regarding the project.",
    issueNotFound: "Issue not found.",
    issueCreated: "Issue created successfully!",
    issueUpdated: "Issue updated successfully!",
    failIssueCreated: "Error while creating the issue.",
    failIssueUpdated: "Error while updating the issue.",
    draft: {
      label: "Draft",
      editing: "Editing draft",
      create: "Create as draft",
      publish: "Publish issue",
      moreOptions: "More creation options",
      created: "Draft created successfully!",
      updated: "Draft updated successfully!",
      published: "Draft published successfully!",
      failCreate: "Error while creating the draft.",
      failUpdate: "Error while updating the draft.",
      failPublish: "Error while publishing the draft.",
    },
    list: {
      filterText: "Filter issues",
      tabs: {
        issues: "Issues",
        drafts: "Draft",
      },
      count: {
        issues: "issues",
        drafts: "drafts",
      },
      untitledDraft: "Untitled draft",
      selectIssue: "Select {{title}}",
      selection: {
        clear: "Clear selected issues",
        selectedOne: "selected",
        selectedMany: "selected",
        generateReport: "Generate PDF report",
        testAction: "Action {{number}}",
        more: "More",
      },
      emptyTitle: "Issues",
      emptyDescription: "Your issues will appear here.",
      emptyAction: "Create your first issue",
      emptyDraftTitle: "Draft issues",
      emptyDraftDescription: "Your draft issues will appear here.",
    },
    chat: {
      title: "Messages",
      open: "Open messages",
      close: "Close messages",
      pin: "Pin messages",
      unpin: "Unpin messages",
      unseenMessages: "New messages",
      placeholder: "Write a message...",
      send: "Send message",
      addAttachment: "Add attachment",
      addImage: "Add image",
      addFile: "Add file",
      recordAudio: "Record audio",
      delete: "Delete message",
      deleteConfirmationTitle: "Delete message?",
      deleteConfirmationDescription:
        "This message will be permanently removed.",
      messageActions: "Message actions",
      today: "Today",
      loadOlder: "Load older messages",
      emptyTitle: "No messages yet",
      emptyDescription: "Start the conversation about this issue.",
      loadError: "Messages could not be loaded.",
      sendError: "Message could not be sent.",
      sending: "Sending...",
      failed: "Not sent",
      deleteError: "Message could not be deleted.",
      system: "System",
    },
    orderBy: {
      newest: "Newest",
      oldest: "Oldest",
    },
    status: {
      open: "Open",
      checking: "Analysing",
      inProgress: "In progress",
      closed: "Resolved",
      archived: "Archived",
    },
    board: {
      description: "Move issues between lanes to keep their status up to date.",
      emptyLane: "Drop an issue here",
      tasks: "Tasks",
    },
    priority: {
      low: "Low",
      moderate: "Moderate",
      high: "High",
      critical: "Critical",
    },
    location: {
      storeyLabel: "Storey",
      areaLabel: "Area",
      empty: "No location",
    },
    confirmArchive: {
      title: "Archive issue?",
      text: "This action is irreversible. Once archived, this entry will be permanently read-only and can no longer be edited.",
      action: "Archive issue",
    },
    image: "Issue image",
    validImages: "PNG, JPG or WEBP.",
    archivedIssueWarning: "Archived issues can't be modified",
    attachmentLimitReached:
      "The limit of {{maxAttachments}} attachments was reached.",
  },
  jobs: {
    activeLabel: "Active processes",
    statusLabel: "Process status",
    dismiss: "Dismiss process status",
    processingDescription: "You can keep working while this finishes.",
    progress: {
      ariaLabel: "Processing progress",
      count: "{{current}} of {{total}} elements",
      finalizing: "Finalizing geometry",
      thumbnail: "Generating model preview",
      lessThanMinute: "Less than a minute remaining",
      minutesRemaining: "About {{count}} min remaining",
      hoursRemaining: "About {{hours}}h {{minutes}}m remaining",
    },
    generic: {
      progressTitle: "Processing your request",
      readyTitle: "Your process is complete",
      readyDescription: "The result is ready.",
    },
    bcf: {
      progressTitle: "Importing your BCF",
      readyTitle: "Your BCF import is complete",
      readyDescription:
        "The imported issues are ready. Their details will appear here once BCF import is enabled.",
    },
    report: {
      confirmTitle: "Generate issue report?",
      confirmDescription:
        "A PDF report will be generated from {{count}} selected issue(s).",
      confirmAction: "Generate report",
      createError: "The report could not be started. Please try again.",
      progressTitle: "Generating your report",
      progressDescription:
        "The selected issues are being assembled into a PDF report.",
      readyTitle: "Your report is ready",
      readyDescription:
        "The PDF containing {{count}} issue(s) is ready to download.",
      download: "Download PDF",
      downloadError: "A download link could not be created. Please try again.",
    },
    ifc: {
      progressTitle: "Processing your IFC model",
      progressDescription:
        "The model geometry is being prepared. You can keep working while it finishes.",
      thumbnailDescription:
        "The geometry is ready. We are generating the model previews now.",
      readyTitle: "Your IFC model is ready",
      readyDescription:
        "Geometry for {{count}} element(s) was processed successfully.",
      readyWithPreviewWarning:
        "The model is ready, but its preview could not be generated. You can still open it normally.",
    },
    federationThumbnail: {
      progressTitle: "Generating the federation preview",
      progressDescription:
        "The federation is ready to open while we render its combined preview.",
      readyTitle: "Federation preview ready",
      readyDescription: "The combined model preview is now available.",
    },
    details: {
      loading: "Loading process details...",
      loadErrorTitle: "Process not found",
      loadErrorDescription:
        "The process may no longer be available or you may not have access to it.",
      failedTitle: "The process did not finish",
      failedDescription: "Please try starting it again.",
    },
  },
};
